import React from 'react';
/* eslint-disable */
export function Mail(props: React.ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M10 12.4023C9.53516 12.4023 9.07031 12.2383 8.6875 11.9375L3 7.50781V13.6875C3 14.4258 3.57422 15 4.3125 15H15.6875C16.3984 15 17 14.4258 17 13.6875V7.50781L11.2852 11.9375C10.9023 12.2383 10.4375 12.4023 10 12.4023ZM3.4375 6.74219L9.23438 11.2539C9.67188 11.582 10.3008 11.582 10.7383 11.2539L16.5352 6.74219C16.8086 6.52344 17 6.19531 17 5.8125C17 5.10156 16.3984 4.5 15.6875 4.5H4.3125C3.57422 4.5 3 5.10156 3 5.8125C3 6.19531 3.16406 6.52344 3.4375 6.74219Z"
        fill="currentColor"
      />
    </svg>
  );
}
<svg width="14" height="11" viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M7 8.40234C6.53516 8.40234 6.07031 8.23828 5.6875 7.9375L0 3.50781V9.6875C0 10.4258 0.574219 11 1.3125 11H12.6875C13.3984 11 14 10.4258 14 9.6875V3.50781L8.28516 7.9375C7.90234 8.23828 7.4375 8.40234 7 8.40234ZM0.4375 2.74219L6.23438 7.25391C6.67188 7.58203 7.30078 7.58203 7.73828 7.25391L13.5352 2.74219C13.8086 2.52344 14 2.19531 14 1.8125C14 1.10156 13.3984 0.5 12.6875 0.5H1.3125C0.574219 0.5 0 1.10156 0 1.8125C0 2.19531 0.164062 2.52344 0.4375 2.74219Z"
    fill="white"
  />
</svg>;
